export const Paths = {
  ROOT: '/',
  HOME_PATH: '/details/table',
  FREE_HOME_PATH: '/settings',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  PROCUREMENT_TABLE_PAGE: '/details/table',
  TENDER_PAGE: ':id',
  PROCUREMENT_DETAILS_PAGE: '/procurement-details/',
  BIDDING_PAGE: 'bid/:id',
  TASK_PAGE: ':id' /* '/bid/:bidId/task/:id' */,
  TASK_ROUTE: '/task/',
  SETTINGS_PAGE: '/settings/',
  SETTINGS_PAGE_COMPANY_INFO: 'company',
  SETTINGS_PAGE_COMPANY_WEBHOOKS: 'webhooks',
  SETTINGS_PAGE_COMPANY_TOKENS: 'tokens',
  SETTINGS_PAGE_COMPANY_SECURITY: 'security',
  SETTINGS_PAGE_CUSTOM_BID_FIELDS: 'customBidFields',
  SETTINGS_PAGE_ACCOUNT: 'account',
  SETTINGS_PAGE_NOTIFICATIONS: 'notifications',
  SETTINGS_PAGE_EMPLOYEES: 'employees',
  SETTINGS_PAGE_COMPETITORS: 'competitors',
  ANALYTICS_PAGE: '/analytics/',
  BUYERS_PAGE: 'buyer-profiles',
  BUYER_PAGE: 'buyer-profiles/:orgId',
  EXPIRING_CONTRACTS_PAGE: 'expiring-contracts',
  ADMIN_PAGE: '/admin/',
  ADMIN_PAGE_USERS_LIST: 'users',
  ADMIN_PAGE_COMPANIES_LIST: 'companies',
  ADMIN_PAGE_COMPANY_INFO: 'company/:companyId',
  AUTH: '/auth/',
  SIGN_IN: '/auth/sign-in',
  SIGN_IN_SSO: '/auth/sign-in-sso',
  SIGN_UP: '/auth/sign-up',
  CONFIRM_SIGN_UP: '/auth/confirm-sign-up',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',
  CHANGE_PASSWORD: '/auth/change-password',
  CONFIRM_2FA: '/auth/confirm-sign-in',
  SETUP_2FA: '/auth/setup-mfa',
  START: '/start/',
  COMPANY_INFO: '/start/company',
  INVITE_TEAM: '/start/invite',
  NOTIFICATIONS_PAGE: '/notifications',
  RAMA: '/rama',
  TENDER_ROUTE: '/tender/',
  BIDDING_GPT: '/response-generator',
  MONITORING: '/monitoring',
  CALL_OFFS: '/call_offs',
  BIDSPACES: '/bidspaces'
};
